import { render, staticRenderFns } from "./OrganizProfessorRegister.vue?vue&type=template&id=49069e6a&scoped=true&"
import script from "./OrganizProfessorRegister.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrganizProfessorRegister.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./OrganizProfessorRegister.vue?vue&type=style&index=0&id=49069e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49069e6a",
  null
  
)

export default component.exports